import { render } from "./CategoryTreeItemComponent.vue?vue&type=template&id=deb2d868"
import script from "./CategoryTreeItemComponent.vue?vue&type=script&lang=js"
export * from "./CategoryTreeItemComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__